export default __webpack_public_path__ + "static/media/slider_image_02-md@1x.22b19be4.webp";